import { useEffect, useState } from "react";

import { PalAutoComplete, PalTypography } from "@palamar/fe-library";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Grid } from "@mui/material";

import { selectUserInfo } from "~store/user/selectors";

import { StepContainer } from "../CommonComponents";

function StepProjectSelect({ formik, setFieldValue, stepKey }) {
  const { t } = useTranslation();
  const userInfo = useSelector(selectUserInfo);
  const [projectOptions, setProjectOptions] = useState([]);

  useEffect(() => {
    if (userInfo.project_roles?.length > 1) {
      const options = userInfo.project_roles.map((role) => ({
        label: role.project_name,
        value: role.project,
      }));
      setProjectOptions(options);
    }
  }, [userInfo]);

  const handleChangeProject = (e, value) => {
    setFieldValue("selected_project", value?.value || null);
  };

  return (
    <StepContainer>
      <Grid container spacing={2}>
        <Grid item mb={2} xs={12}>
          <PalTypography color="textPrimary" fontWeight={600} variant="h5">
            {t("dashboard.onboarding.selectProjectTitle")}
          </PalTypography>
          <PalTypography gutterBottom variant="body1">
            {t("dashboard.onboarding.selectProjectDescription")}
          </PalTypography>
        </Grid>
        <Grid item xs={12}>
          <PalTypography gutterBottom fontWeight={600} variant="body1">
            {t("dashboard.onboarding.selectProjectLabel")}
          </PalTypography>
          <PalAutoComplete
            fullWidth
            invalid={formik.touched[stepKey]?.selected_project && formik.errors[stepKey]?.selected_project}
            options={projectOptions}
            placeholder={t("dashboard.onboarding.selectProjectPlaceholder")}
            value={formik.values[stepKey]?.selected_project}
            onChange={handleChangeProject}
          />
        </Grid>
      </Grid>
    </StepContainer>
  );
}

export default StepProjectSelect;
